import React from 'react';
import {Link} from 'react-router-dom';


export default class Component extends React.Component {

  render (){

    return (
      <section id="popular" className="content-section text-center py-5 my-5">
        <h2 className="text-center">Build your own portfolio</h2>
        <div className="text-center">


          <div className="my-5">
          <Link  to="/signup" className="btn btn-lg btn-black text-white">
            Build a custom portfolio!
          </Link>
          </div>
          
        </div>
      </section>
    )
  }
}